import { isProd } from "@/config/common";
import {
  ContentfulLocaleEnum,
  CountryCodeEnum,
  CountryNameEnum,
  CurrencyCodeEnum,
  DomainEnum,
  ElevateCodeEnum,
  LanguageCodeEnum,
  type Market,
  PSPEnum,
  SiteLocaleEnum,
  SiteNameEnum,
} from "./i18n-config";

export const fi: Market = {
  psp: PSPEnum.WALLEY,
  flag: "🇫🇮",
  currency: CurrencyCodeEnum.EUR,
  countryCode: CountryCodeEnum.FI,
  countryName: CountryNameEnum.FI,
  languageCode: LanguageCodeEnum.FI,
  locale: `${LanguageCodeEnum.FI}-${CountryCodeEnum.FI}`,
  upperCaseLocale: `${LanguageCodeEnum.FI}-${CountryCodeEnum.FI.toUpperCase()}`,
  contentfulLocale: ContentfulLocaleEnum.FI,
  siteLocale: SiteLocaleEnum.FI,
  elevateMarket: ElevateCodeEnum.FI,
  externalStoreId: "ecom-fi",
  walleyStoreCodeB2B: isProd() ? 11449 : 6352,
  walleyStoreCodeB2C: isProd() ? 11448 : 6351,
  searchPathName: "/haku",
  domain: DomainEnum.NOGA,
  imageCdn: isProd()
    ? "https://cdn.no-ga.com"
    : "https://media.stage.cdn-norce.tech/1413",
  siteName: SiteNameEnum.FI,
};
